
import { Component, Vue } from 'vue-property-decorator'
import { apiPaymentConfigSet, apiPaymentConfigGet } from '@/api/setting'
import MaterialSelect from '@/components/material-select/index.vue'
@Component({
    components: {
        MaterialSelect
    }
})
export default class PayMethodEdit extends Vue {
    /** S Data **/

    identity: Number = 0

    status: any = ''

    // ข้อมูลสำหรับการตั้งค่าการกำหนดค่าการชำระเงิน
    paymentConfigData = {
        name: '', //ชื่อการชำระเงิน
        icon: '', //ไอคอนการชำระเงิน
        sort: '', //เรียงลำดับ
        remark: '', //หมายเหตุ
        merchant_type: '', //（วีแชต เพย์ ｜｜ อาลีเพย์）ประเภทผู้ค้าordinary_merchant-พ่อค้าธรรมดา
        interface_version: 'v2', //เวอร์ชันอินเทอร์เฟซการชำระเงิน WeChatv2-v2
        mch_id: '', //บัญชีผู้ค้าชำระเงิน WeChat
        pay_sign_key: '', //การชำระเงินร้านค้า WeChatAPIสำคัญ
        apiclient_cert: '', //ใบรับรองการชำระเงิน WeChat
        apiclient_key: '', //รหัสใบรับรองการชำระเงิน WeChat
        pattern: '', //แบบอย่าง：normal_modeพ่อค้าธรรมดา
        app_id: '', //แอปพลิเคชันID
        private_key: '', //อาลีเพย์กุญแจสาธารณะ
        ali_public_key: '', //ใช้รหัสส่วนตัว
        pay_way: '',
    }

    // การตรวจสอบแบบฟอร์ม
    rules: any = {
        name: [{ required: true, message: 'กรุณากรอกชื่อที่แสดง', trigger: 'blur' }],
        icon: [{ required: true, message: 'กรุณาใส่ไอคอนอัพโหลด', trigger: 'change' }],
        mch_id: [
            {
                required: true,
                message: 'กรุณากรอกช่องนี้',
                trigger: 'blur'
            }
        ],
        pay_sign_key: [
            {
                required: true,
                message: 'กรุณากรอกช่องนี้',
                trigger: 'blur'
            }
        ],
        apiclient_cert: [{ required: true, message: 'กรุณากรอกช่องนี้', trigger: 'blur' }],
        apiclient_key: [
            {
                required: true,
                message: 'กรุณากรอกช่องนี้',
                trigger: 'blur'
            }
        ],
        private_key: [{ required: true, message: 'กรุณากรอกช่องนี้', trigger: 'blur' }],
        ali_public_key: [{ required: true, message: 'กรุณากรอกช่องนี้', trigger: 'blur' }],
        app_id: [{ required: true, message: 'กรุณากรอกช่องนี้', trigger: 'blur' }],
        sort: [
            { required: true, message: 'กรุณากรอกการเรียงลำดับ', trigger: 'blur' },
            {
                type: 'number',
                pattern: !/-|\+|(\.[0-9])/,
                message: 'กรุณากรอกการเรียงลำดับที่ถูกต้อง',
                trigger: 'blur'
            }
        ]
    }

    /** E Data **/

    /** S Methods **/

    // รับข้อมูลวิธีการชำระเงิน
    getPaymentConfigDetail() {
        apiPaymentConfigGet({
            id: this.identity
        })
            .then((res: any) => {
                // ถอดรหัสผลลัพธ์
                const result = {
                    ...res.config,
                    ...res
                }

                delete result.config

                if (result.pay_way == 2) {
                    result.interface_version = 'v2'
                }
                if (result.pay_way == 3) {
                    result.mode = 'normal_mode'
                }
                result.merchant_type = 'ordinary_merchant'

                this.paymentConfigData = result
            })
            .catch(() => {
                this.$message.error('การเริ่มต้นข้อมูลล้มเหลว，โปรดรีเฟรชและโหลดซ้ำ！')
            })
    }

    // คลิกเพื่อส่งแบบฟอร์ม
    onSubmit(formName: string) {
        // ตรวจสอบว่ารูปแบบแบบฟอร์มถูกต้อง
        const refs = this.$refs[formName] as HTMLFormElement
        refs.validate((valid: boolean): any => {
            if (!valid) {
                return
            }
            if ((this.paymentConfigData as any).sort <= 0) {
                return this.$message.error('โปรดป้อนจำนวนเต็มบวก')
            }
            this.handlePayConfigEdit()
        })
    }

    // แก้ไขการกำหนดค่าการชำระเงิน
    handlePayConfigEdit() {
        const params = this.paymentConfigData
        const id: number = this.identity as number
        apiPaymentConfigSet({ ...params, id })
            .then(() => {
                setTimeout(() => this.$router.go(-1), 500)
            })
            .catch(() => {
                this.$message.error('บันทึกล้มเหลว!')
            })
    }

    // คัดลอกชื่อโดเมน
    onCopy() {
        const createInput = document.createElement('input')
        createInput.value = 'https://app.litesites.co/plat/webhook.php'
        document.body.appendChild(createInput)
        createInput.select() // เลือกวัตถุ
        document.execCommand('Copy') // ดำเนินการคำสั่งคัดลอกเบราว์เซอร์
        createInput.style.display = 'none'
        this.$message({ message: 'คัดลอกเรียบร้อยแล้ว', type: 'success' })
    }
  onCopy2() {
        const createInput = document.createElement('input')
        createInput.value = 'https://app.litesites.co/adminapi/settings.shop.renew/notifyOa'
        document.body.appendChild(createInput)
        createInput.select() // เลือกวัตถุ
        document.execCommand('Copy') // ดำเนินการคำสั่งคัดลอกเบราว์เซอร์
        createInput.style.display = 'none'
        this.$message({ message: 'คัดลอกเรียบร้อยแล้ว', type: 'success' })
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        const query: any = this.$route.query
        this.identity = query.id
        this.getPaymentConfigDetail()
    }
    /** E Life Cycle **/

    /** S Compute Attr **/


    /** E Compute Attr **/
}
